import React from 'react';
import { Link } from 'react-router-dom';
import LegalDocumentLayout from './LegalDocumentLayout';

export default function SmsConsentPage() {
  return (
    <LegalDocumentLayout title="SMS Notification Consent" card>
      <h2>Program name and sender</h2>
      <p>
        Messages are sent by Rynn from Sovrynn. Rynn is Sovrynn&apos;s AI assistant.
      </p>

      <h2>What we send</h2>
      <p>
        Compliance and expiration alerts are active now, including CDL, medical card, and inspection
        deadline notices. Two-way texting about your own account, including photos, is rolling out and
        will be added as it launches.
      </p>

      <h2>How we collect consent</h2>
      <p>
        SMS is optional. When you create a Sovrynn account, you may provide a mobile number and check a
        box to opt in. Providing a number without checking the box does not opt you in. Consent is not a
        condition of purchase.
      </p>

      <h2>Frequency and rates</h2>
      <p>
        Message frequency varies. Message and data rates may apply.
      </p>

      <h2>Keywords</h2>
      <p>
        Reply STOP to opt out at any time. Reply HELP for help. Reply START to opt back in.
      </p>

      <h2>Support</h2>
      <p>
        For support, visit{' '}
        <a href="https://sovrynn.co/support">sovrynn.co/support</a>.
      </p>

      <p className="legal-page__links">
        <Link to="/privacy">Privacy Policy</Link>
        {' · '}
        <Link to="/terms">Terms of Service</Link>
      </p>
    </LegalDocumentLayout>
  );
}
